/*
 * ForeFront UX fixes (Oct 21 2026)
 * A small, self-contained layer loaded after the theme scripts.
 * 1. Printer search: matches word by word and ignores brand words,
 *    so "epson c3500", "Epson TM C3500 printer" and "lx 910" all work.
 * 2. Plain-English wording in the finder (no app names, no internal codes).
 * 3. Inch marks on label sizes, quantity box snaps to a valid number.
 * 4. Removes the "conflicting dimensions" warning from product pages.
 * 5. Keeps the "Added to cart" popup above the chat bubble.
 * When the finder source is cleaned up, fold these changes into it and delete this file.
 */
(function () {
  'use strict';

  /* ---------- 1. Printer search ---------- */
  var STOP_WORDS = {
    epson: 1, colorworks: 1, color: 1, colour: 1, works: 1, primera: 1, afinia: 1,
    vipcolor: 1, vip: 1, uninet: 1, icolor: 1, printer: 1, printers: 1, label: 1,
    labels: 1, for: 1, the: 1, my: 1, tm: 1, cw: 1, lx: 1, vp: 1, inkjet: 1, ink: 1,
    roll: 1, rolls: 1, and: 1
  };
  var lastQuery = '';

  var normalize = function (value) {
    return String(value || '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();
  };

  var escapeRe = function (t) { return t.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); };

  // A word matches when it starts with the token, or is letters then the token ("c3500" for "3500").
  // Strict mode stops "200" matching "lx2000"; loose mode lets a half-typed model ("c35") match.
  var tokenHits = function (words, compact, token, strict) {
    var re = new RegExp('^[a-z]*' + escapeRe(token) + (strict ? '(?![0-9])' : ''));
    for (var i = 0; i < words.length; i += 1) if (re.test(words[i])) return true;
    return token.length >= 5 && /[a-z]/.test(token) && /[0-9]/.test(token) && compact.indexOf(token) !== -1;
  };

  var printerHaystack = function (printer) {
    var haystack = normalize([
      printer.name, printer.model, printer.brandName, printer.brand
    ].concat((printer.aliases || []).filter(function (a) { return typeof a === 'string'; })).join(' '));
    return { words: haystack.split(' '), compact: haystack.replace(/\s+/g, '') };
  };

  var matchWith = function (printer, required, strict) {
    var h = printerHaystack(printer);
    return required.every(function (t) { return tokenHits(h.words, h.compact, t, strict); });
  };

  var strictCache = { query: null, value: false };
  var printerMatches = function (printer, query) {
    var tokens = normalize(query).split(' ').filter(Boolean);
    if (!tokens.length) return false;
    var meaningful = tokens.filter(function (t) { return !STOP_WORDS[t]; });
    var required = meaningful.length ? meaningful : tokens;
    // Use strict matching when at least one printer matches the query exactly.
    if (strictCache.query !== query) {
      var all = ((window.ForeFrontFinderData || {}).printers) || [];
      strictCache = { query: query, value: all.some(function (p) { return matchWith(p, required, true); }) };
    }
    return matchWith(printer, required, strictCache.value);
  };

  // The finder joins each printer's aliases into one string and checks it contains the query.
  // This alias object turns into the query text only when the word-by-word match succeeds.
  var installSmartAlias = function () {
    var data = window.ForeFrontFinderData || {};
    var printers = Array.isArray(data.printers) ? data.printers : [];
    printers.forEach(function (printer) {
      if (!Array.isArray(printer.aliases)) printer.aliases = [];
      if (printer.__ffSmartAlias) return;
      printer.__ffSmartAlias = true;
      printer.aliases.push({
        toString: function () {
          var q = String(lastQuery || '').trim();
          return q && printerMatches(printer, q) ? q : '';
        }
      });
    });
  };

  document.addEventListener('input', function (event) {
    var t = event.target;
    if (t && t.matches && (t.matches('[data-ffsf-printer-search]') || t.matches('[data-ffsf-hero-search]'))) {
      lastQuery = t.value;
    }
  }, true);
  document.addEventListener('click', function (event) {
    var t = event.target && event.target.closest && event.target.closest('[data-action]');
    if (!t) return;
    var action = t.getAttribute('data-action');
    if (action === 'hero-match' || action === 'deal-start') {
      var hero = document.querySelector('[data-ffsf-hero-search]');
      lastQuery = hero ? hero.value : '';
    } else if (action === 'clear-search' || action === 'start-over') {
      lastQuery = '';
    }
  }, true);

  /* ---------- 2 + 3. Wording and inch marks ---------- */
  var REPLACEMENTS = [
    [/view the exact product and live Shopify price\./g, 'view the exact product and current price.'],
    [/The live Shopify variant is verified again before cart addition\./g, 'Availability is checked again before anything goes in your cart.'],
    [/Eligible DealEasy savings apply automatically in cart and checkout\./g, 'Bulk savings apply automatically in your cart.'],
    [/before anything is added to Shopify cart\./g, 'before anything is added to your cart.'],
    [/Shopify cart and checkout will still apply any eligible automatic discount\./g, 'Your cart and checkout will still apply any eligible bulk discount.'],
    [/add the live Shopify variant directly to your cart\./g, 'add the exact roll to your cart.'],
    [/(^|[^-\w])(\d)C(\d+)OD(?!\w)/g, '$1$2" core, $3" roll'],
    [/(\d+(?:\.\d+)?) x (\d+(?:\.\d+)?)(?![\d."])/g, '$1" x $2"']
  ];
  var PAGE_REPLACEMENTS = [
    [/\s*Confirm conflicting dimensions or counts with ForeFront before ordering\./g, ''],
    [/\s*Label specifications conflict; verify before ordering\./g, '']
  ];

  var rewriteText = function (root, rules) {
    if (!root) return;
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function (node) {
        var parent = node.parentNode;
        if (!parent) return NodeFilter.FILTER_REJECT;
        var tag = parent.nodeName;
        if (tag === 'SCRIPT' || tag === 'STYLE' || tag === 'TEXTAREA' || tag === 'OPTION') return NodeFilter.FILTER_REJECT;
        return NodeFilter.FILTER_ACCEPT;
      }
    });
    var node;
    while ((node = walker.nextNode())) {
      var before = node.nodeValue;
      var after = before;
      for (var i = 0; i < rules.length; i += 1) after = after.replace(rules[i][0], rules[i][1]);
      if (after !== before) node.nodeValue = after;
    }
  };

  var watch = function (root, rules) {
    rewriteText(root, rules);
    var scheduled = false;
    var observer = new MutationObserver(function () {
      if (scheduled) return;
      scheduled = true;
      window.requestAnimationFrame(function () {
        scheduled = false;
        observer.disconnect();
        rewriteText(root, rules);
        observer.observe(root, { childList: true, subtree: true, characterData: true });
      });
    });
    observer.observe(root, { childList: true, subtree: true, characterData: true });
  };

  /* Quantity box: snap to 1 to 999 when the shopper leaves the field */
  document.addEventListener('change', function (event) {
    var t = event.target;
    if (!t || !t.matches || !t.matches('[data-ffsf-quantity]')) return;
    var raw = Math.floor(Number(t.value));
    var clean = Math.max(1, Math.min(999, raw || 1));
    if (String(clean) !== String(t.value)) {
      t.value = clean;
      t.dispatchEvent(new Event('input', { bubbles: true }));
    }
    var note = t.closest('.ffsf-quantity-row') && t.closest('.ffsf-quantity-row').parentNode.querySelector('[data-ff-qty-note]');
    if (raw > 999) {
      if (!note && t.closest('.ffsf-quantity-row')) {
        note = document.createElement('p');
        note.setAttribute('data-ff-qty-note', '');
        note.style.cssText = 'margin:6px 0 0;font-size:13px;color:#b42318';
        t.closest('.ffsf-quantity-row').insertAdjacentElement('afterend', note);
      }
      if (note) note.textContent = 'Online orders go up to 999 rolls. For more, contact us for a volume quote.';
    } else if (note) {
      note.remove();
    }
  }, true);

  /* ---------- 5. Popup above the chat bubble ---------- */
  var style = document.createElement('style');
  style.textContent = '.ffsf-toast{bottom:104px!important;z-index:2147483000!important}';
  document.head.appendChild(style);

  var start = function () {
    installSmartAlias();
    document.querySelectorAll('[data-ffsf-finder]').forEach(function (root) { watch(root, REPLACEMENTS); });
    var main = document.getElementById('MainContent');
    if (main) watch(main, PAGE_REPLACEMENTS);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
